import "@react-pdf-viewer/core/lib/styles/index.css";
import "./pages.css";
import { Link } from "react-router-dom";
import Header from "../Header";

function CastCrew() {
  return (
    <div className="main-container">
      <Link to="/" className="link-reset">
        <Header />
      </Link>
      <div>
        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Tiffany Lin Fu</span>
            <span className="cast-title">Director / Producer</span>
          </h3>
          <p>
            Inspired by Everything Everywhere All At Once, Alice Wu, Kurt
            Vonnegut, tiny homes, and fun hats. A first-time director / producer
            / human. Left brain enjoys finite state machines, right brain enjoys
            sketching and typography.
          </p>
        </div>
        <img
          src="/tiffany_card.png"
          alt="Tiffany Fu"
          className="cast_cards"
          width="380px"
        />

        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Marisol Kim</span>
            <span className="cast-title">Producer</span>
          </h3>
          <p>Enjoys reading Substacks and crocheting amigurumi.</p>
        </div>

        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Aleeza Mirza</span>
            <span className="cast-title">Director of Photography</span>
          </h3>
          <p>Enjoys learning languages and following her intuition.</p>
        </div>

        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Gabreanna Soberano</span>
            <span className="cast-title">Production Designer</span>
          </h3>
          <p>Enjoys sudoko and doodling.</p>
        </div>

        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Amelia Hemmings</span>
            <span className="cast-title">Assistant Director</span>
          </h3>
          <p>Enjoys LinkedIn daily games and listening to music.</p>
        </div>

        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Jemma Mines</span>
            <span className="cast-title">Assistant Camera</span>
          </h3>
          <p>Enjoys learning languages and playing guitar.</p>
        </div>

        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Francesca Lloyd</span>
            <span className="cast-title">Camera Operator</span>
          </h3>
          <p>Enjoys playing bananagrams and writing fiction stories.</p>
        </div>

        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Eden Chung</span>
            <span className="cast-title">Sound Recordist</span>
          </h3>
          <p>
            Enjoys building mechanical keyboards and designing houses in the
            Sims.
          </p>
        </div>

        <div className="cast-bio">
          <h3 className="cast-header">
            <span className="cast-name">Sara Lin</span>
            <span className="cast-title">MUA / Costume</span>
          </h3>
          <p>
            Enjoys soduko along with knitting and writing.
          </p>
        </div>

      </div>
    </div>
  );
}

export default CastCrew;
